import { useMutation, useQueryClient } from '@tanstack/react-query';
import { messageKeys } from '../messageKeys';
import { messagesService } from '../messagesService';

/**
 * GOTU-5602: without invalidating, the office returns from a chat to a cached list
 * (staleTime 30s, no refetch on focus) still showing the unread dot. `jobMessages` is
 * left alone so the open chat does not refetch itself.
 */
export function useMarkConversationRead() {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>({
    mutationFn: (jobId: string) => messagesService.markConversationRead(jobId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: messageKeys.conversationsRoot() });
      queryClient.invalidateQueries({ queryKey: messageKeys.unreadCount() });
    },
  });
}
